"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-console */
var amazon_config_store_model_tscommon_1 = require("@amzn/amazon-config-store-model-tscommon");
/**
 * Abstract base class for shared code of WeblabRulesResolverImpl and WeblabRulesAsyncResolverImpl
 */
var WeblabRulesResolverAbstract = /** @class */ (function () {
    function WeblabRulesResolverAbstract(weblabTreatmentResolver, weblabWithContextTreatmentResolver) {
        if (weblabTreatmentResolver && weblabWithContextTreatmentResolver) {
            var errorMsg = 'You should not define both types of resolvers. At maximum one of '
                + '`weblabTreatmentResolver` or `weblabWithContextTreatmentResolver` should be defined.';
            throw new amazon_config_store_model_tscommon_1.ACSClientError(errorMsg);
        }
        this.weblabTreatmentResolver = weblabTreatmentResolver;
        this.weblabWithContextTreatmentResolver = weblabWithContextTreatmentResolver;
    }
    /**
     * validates the input, prints warnings and returns whether the input was valid
     */
    WeblabRulesResolverAbstract.prototype.validateInput = function (weblabContext, weblabRules) {
        if (!weblabRules || weblabRules.length === 0) {
            return false;
        }
        var weblabContextDefinedButNoContextResolver = weblabContext !== undefined
            && !this.weblabWithContextTreatmentResolver;
        if (weblabContextDefinedButNoContextResolver) {
            var warningMsg = 'Weblab rules are NOT applied and the default value is used as no '
                + 'WeblabWithContextTreatmentResolver resolver was defined at client initialisation time. '
                + 'Please make sure you provide one. Until then we are using the default value and not taking '
                + 'the weblab rules into account.';
            console.warn(warningMsg);
            return false;
        }
        if (!this.weblabTreatmentResolver && !this.weblabWithContextTreatmentResolver) {
            var warningMsg = 'Weblab rules are NOT applied and the default value is used as '
                + 'no resolver was defined. Please make sure a weblab resolver is defined.';
            console.warn(warningMsg);
            return false;
        }
        var noWeblabContextButContextResolverDefined = !weblabContext
            && this.weblabWithContextTreatmentResolver !== undefined;
        if (noWeblabContextButContextResolverDefined) {
            var warningMsg = 'Weblab rules are NOT applied and the default value is used as '
                + 'no WeblabContext was provided to the ACS typesafe client. Please make sure you provide one. '
                + 'Until then we are using the default value and not taking the weblab rules into account.';
            console.warn(warningMsg);
            return false;
        }
        return true;
    };
    /**
     * evaluates an expression given a map of weblab names and their respective active treatments
     */
    WeblabRulesResolverAbstract.prototype.isWeblabExpressionTrue = function (operands, operator, weblabTreatmentMap) {
        var _this = this;
        var validator = function (operand) { return _this.isWeblabOperandTrue(operand, weblabTreatmentMap); };
        return operator === amazon_config_store_model_tscommon_1.WeblabRuleOperator.OR
            ? operands.some(validator) : operands.every(validator);
    };
    /**
     * evaluates an operand given a map of weblab names and their respective active treatments
     */
    WeblabRulesResolverAbstract.prototype.isWeblabOperandTrue = function (operand, weblabTreatmentMap) {
        var _a = this.getWeblabNameAndTreatementFromStr(operand), name = _a.name, treatment = _a.treatment;
        var activeTreatment = weblabTreatmentMap.get(name);
        return treatment === activeTreatment;
    };
    /**
     * gets all weblab names that exist in the rules as operands
     */
    WeblabRulesResolverAbstract.prototype.getDistinctWeblabNames = function (weblabRules) {
        var _this = this;
        return new Set(weblabRules
            .flatMap(function (rule) { return rule.operands; })
            .map(function (operand) { return _this.getWeblabNameAndTreatementFromStr(operand).name; }));
    };
    /**
     * decomposes string into operand and treatment
     */
    WeblabRulesResolverAbstract.prototype.getWeblabNameAndTreatementFromStr = function (operand) {
        var splittedOperand = operand.split(':');
        return {
            name: splittedOperand[0],
            treatment: splittedOperand[1],
        };
    };
    /**
     * finds value for role in treatement map if exists
     */
    WeblabRulesResolverAbstract.prototype.findMatchingValue = function (weblabRules, weblabTreatmentMap) {
        var _this = this;
        var _a;
        return (_a = weblabRules.find(function (weblabRule) { return _this.isWeblabExpressionTrue(weblabRule.operands, weblabRule.operator, weblabTreatmentMap); })) === null || _a === void 0 ? void 0 : _a.use;
    };
    return WeblabRulesResolverAbstract;
}());
exports.default = WeblabRulesResolverAbstract;
